
<template>
  <div id="page-mail-error-list" class="vx-card p-6">
    <!-- Searchs-->
    <vx-card
      ref="filterCard"
      class="mail-error-list-filters mb-8"
      actionButtons
      @refresh="resetColFilters"
      @remove="resetColFilters"
    >
      <div class="vx-row">
        <div class="vx-col lg:w-1/4 sm:w-1/2 w-full">
          <label class="text-sm opacity-75">お問い合わせ者</label>
          <vs-input
            class="
              sm:mr-0 sm:w-auto
              w-full
              sm:order-normal
              order-3
              sm:mt-0
              mt-4
            "
            placeholder="FROM（部分一致）"
            v-model="emailSenderSearch"
          >
          </vs-input>
        </div>
        <div class="vx-col lg:w-1/4 sm:w-1/2 w-full">
          <label class="text-sm opacity-75">TO メール</label>
          <vs-input
            class="
              sm:mr-0 sm:w-auto
              w-full
              sm:order-normal
              order-3
              sm:mt-0
              mt-4
            "
            placeholder="TO（部分一致）"
            v-model="toSearch"
          />
        </div>
        <div class="vx-col lg:w-1/4 sm:w-1/2 w-full">
          <label class="text-sm opacity-75">タイトル</label>
          <vs-input
            class="mr-0 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4"
            id="subject_search"
            v-model="subjectSearch"
          >
          </vs-input>
        </div>
        <div class="vx-col lg:w-1/4 sm:w-1/2 w-full">
          <label class="text-sm opacity-75">本文</label>
          <vs-input
            class="mr-0 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4"
            id="body_search"
            v-model="bodySearch"
          >
          </vs-input>
        </div>
        <div class="vx-col lg:w-1/4 sm:w-1/2 w-full">
          <label class="text-sm opacity-75">お問い合わせ日（から）</label>
          <flat-pickr
            id="receive_date_search_from"
            class="w-full flatpickr-style"
            v-model="dateFromSearch"
            placeholder="..."
            :config="configDate"
          >
          </flat-pickr>
        </div>
        <div class="vx-col lg:w-1/4 sm:w-1/2 w-full">
          <label class="text-sm opacity-75">お問い合わせ日（まで）</label>
          <flat-pickr
            id="receive_date_search_to"
            class="w-full flatpickr-style"
            v-model="dateToSearch"
            placeholder="..."
            :config="configDate"
          >
          </flat-pickr>
        </div>
      </div>
      <div
        class="
          vx-col
          lg:w-1/4
          sm:w-1/2
          w-full
          flex flex-wrap
          items-end
          justify-end
          div-search-bnt
        "
      >
        <vs-button
          icon="search"
          @click="
            pageNumber = 1;
            searchMailWithOrder();
          "
          class="search_icon mr-6 sm:mr-3"
          >検索
        </vs-button>
      </div>
    </vx-card>

    <!-- Title and Buttons Action -->
    <vs-row class="pl-2">
      <vs-col class="flex flex-wrap items-center justify-start pl-6" vs-w="6">
        <span class="pr-2">表示件数:</span>
        <div class="vx-col md:w-24 w-full">
          <v-select
            class="
              sm:mr-4 sm:w-auto
              w-full
              sm:order-normal
              order-3
              sm:mt-0
              mt-4
            "
            :options="paginationOptions"
            :dir="$vs.rtl ? 'rtl' : 'ltr'"
            v-model="paginationPageSize"
          >
            <span slot="no-options" class="text-xs"
              >すみません、マッチングオプションがありません。</span
            >
          </v-select>
        </div>
      </vs-col>
    </vs-row>

    <!--PopUp detail-->
    <vs-popup id="dialogDetail" title="メールの情報" :active.sync="activePopUp" button-close-hidden>
      <div id="receive-mail-detail">
        <vs-row >
          <vs-col>
            <vx-input-group class="square">
              <template slot="prepend">
                <div class="prepend-text label-style mail-error">
                  <span>ID</span>
                </div>
              </template>
              <vs-input
                :readonly="isFormInValid"
                :class="isFormInValid ? 'disabled-input' : ''"
                v-model="inquiry_id_detail"
                placeholder="email_sender_full"
              />
            </vx-input-group>
          </vs-col>
          <vs-col>
            <vx-input-group class="square">
              <template slot="prepend">
                <div class="prepend-text label-style mail-error">
                  <span>お問い合わせ日</span>
                </div>
              </template>
              <vs-input
                :readonly="isFormInValid"
                :class="isFormInValid ? 'disabled-input' : ''"
                v-model="receive_date_detail"
                placeholder="email_sender_full"
              />
            </vx-input-group>
          </vs-col>
          <vs-col>
            <vx-input-group class="square">
              <template slot="prepend">
                <div class="prepend-text label-style mail-error">
                  <span>From</span>
                </div>
              </template>
              <vs-input
                :readonly="isFormInValid"
                :class="isFormInValid ? 'disabled-input' : ''"
                v-model="email_sender_detail"
                placeholder="email_sender_full"
              />
            </vx-input-group>
          </vs-col>
          <vs-col>
            <vx-input-group>
              <template slot="prepend">
                <div class="prepend-text label-style mail-error">
                  <span>To</span>
                </div>
              </template>

              <vs-input
                :readonly="isFormInValid"
                :class="isFormInValid ? 'disabled-input' : ''"
                v-model="to_detail"
                placeholder="receive_mail_full"
              />
            </vx-input-group>
          </vs-col>
          <vs-col>
            <vx-input-group>
              <template slot="prepend">
                <div class="prepend-text label-style mail-error">
                  <span>CC</span>
                </div>
              </template>

              <vs-input
                :readonly="isFormInValid"
                :class="isFormInValid ? 'disabled-input' : ''"
                v-model="cc_detail"
              />
            </vx-input-group>
          </vs-col>
        </vs-row>

        <vs-row class="mt-6">
          <vx-card
            class="card-body-mail"
            no-radius
            cardBorder
            noShadow
            title="件名"
            :class="isFormInValid ? 'disabled-input' : ''"
          >
            <div
              class="w-full"
              v-html="subject_detail"
              style="padding: 9.8px"
            ></div>
          </vx-card>

          <vx-card
            class="card-body-mail"
            no-radius
            cardBorder
            noShadow
            title="お問い合わせ本文"
            :class="isFormInValid ? 'disabled-input' : ''"
          >
            <div
              class="pl-2 pt-2"
              v-if="body_type_detail == 0"
              v-html="body_detail"
              style="height: 150px; overflow-y: scroll"
            ></div>
            <vs-textarea
              v-else
              :readonly="isFormInValid"
              v-model="body_detail"
              placeholder="..."
              height="100px"
            />
          </vx-card>
          <vx-card
            class="card-body-mail"
            no-radius
            cardBorder
            noShadow
            title="エラー内容"
            :class="isFormInValid ? 'disabled-input' : ''"
          >
            <div
              class="pl-2 pt-2"
              v-html="error_detail"
              style="height: 200px; overflow-y: scroll"
            ></div>
          </vx-card>
        </vs-row>
        <div style="display: flex; justify-content: flex-end" class="pt-4">
            <vs-button @click="activePopUp = false" icon="cancel" color="lightgrey" style="padding: 8px; margin-right: 5px;height: 37px">閉じる</vs-button>
        </div>
      </div>
    </vs-popup>

    <!-- AgGrid Table -->
    <ag-grid-vue
      id="myGrid"
      ref="agGridTable"
      :gridOptions="gridOptions"
      class="ag-theme-material w-100 my-4 ag-grid-table database"
      :columnDefs="columnDefs"
      :defaultColDef="defaultColDef"
      :rowData="listMailError"
      rowSelection="single"
      colResizeDefault="shift"
      :animateRows="true"
      :pagination="true"
      :domLayout="domLayout"
      :paginationPageSize="paginationPageSize"
      :suppressPaginationPanel="true"
      :enableRtl="$vs.rtl"
      @selection-changed="onSelectionChanged"
      @sortChanged="onSortChangedEvent"
      :overlayNoRowsTemplate="noRowsTemplate"
      :detailRowAutoHeight="true"
    >
    </ag-grid-vue>

    <div style="position: relative">
      <!-- ITEMS PER PAGE -->
      <div>
        <div class="flex items-center justify-between">
          <span class="pl-2 mr-2" style="font: 400 13.3333px Arial"
            >{{ totalRow }} 件中 {{ startRow }} 件から
            {{ endRow }} 件までを表示</span
          >
        </div>
      </div>
      <!-- pagination -->
      <vs-pagination
        :total="totalPages"
        v-model="currentPage"
        :max="7"
        class="pr-10 pt-10"
      />
    </div>
  </div>
</template>

<script>
import "@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss";
import { AgGridVue } from "ag-grid-vue";
import vSelect from "vue-select";
import { mapActions, mapGetters } from "vuex";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import { Japanese } from "flatpickr/dist/l10n/ja.js";
import "@/assets/scss/vuexy/components/view/receivedMailDetail.scss";

export default {
  components: {
    AgGridVue,
    vSelect,
    flatPickr,
  },
  data() {
    return {
      configDate: {
        locale: Japanese,
        wrap: true,
        defaultHour: 0,
        maxDate: "",
      },
      // Filter Options Search
      emailSenderSearch: "",
      toSearch: "",
      subjectSearch: "",
      bodySearch: "",
      dateFromSearch: "",
      dateToSearch: "",
      paginationOptions: [10, 20, 30, 50],

      //SortParams
      orderBy: "id",
      orderDir: "desc",

      //Pagination
      paginationPageSize: 10,
      pageNumber: 1,
      startRow: 0,
      endRow: 0,

      // AgGrid
      noRowsTemplate: "<span>データがありません</span>",
      domLayout: "autoHeight",
      gridApi: null,
      gridOptions: {
        onGridSizeChanged: () => {
          this.gridApi.sizeColumnsToFit();
        },
      },
      defaultColDef: {
        sortable: true,
        resizable: true,
        suppressMenu: true,
        sortingOrder: ["asc", "desc"],
      },
      columnDefs: [
        {
          headerName: "お問い合わせ日",
          field: "receive_datetime",
          width: 180,
          filter: true,
          unSortIcon: true,
          suppressMovable: true,
        },
        {
          headerName: "お問い合わせ者",
          field: "email_sender",
          filter: true,
          width: 250,
          unSortIcon: true,
          suppressMovable: true,
        },
        {
          headerName: "TO メール",
          field: "to",
          filter: true,
          width: 230,
          unSortIcon: true,
          suppressMovable: true,
        },
        {
          headerName: "タイトル ",
          field: "subject",
          filter: true,
          width: 250,
          unSortIcon: true,
          suppressMovable: true,
        },
        {
          headerName: "メール本文",
          field: "parsed_body",
          filter: true,
          width: 250,
          unSortIcon: true,
          suppressMovable: true,
        },
      ],
      //
      activePopUp: false,
      inquiry_id_detail: null,
      receive_date_detail: null,
      email_sender_detail: null,
      to_detail: null,
      cc_detail: null,
      subject_detail: "",
      body_detail: "",
      body_type_detail: 0,
      error_detail: "",
      isFormInValid: true,
    };
  },
  watch: {
    paginationPageSize(val) {
      this.setPagination(val);
    },
    activePopUp() {
      if (!this.activePopUp) {
        this.gridOptions.api.deselectAll();
        this.attachmentFileName_detail = [];
      }
    },
  },
  computed: {
    ...mapGetters({
      listMailError: "mailError/listMailError",
    }),
    totalPages() {
      return parseInt(this.$store.state.mailError.infoDB.totalPage);
    },
    totalRow() {
      return parseInt(this.$store.state.mailError.infoDB.totalRow);
    },
    currentPage: {
      get() {
        return this.pageNumber;
      },
      async set(val) {
        this.pageNumber = val;
        await this.searchMailWithOrder();
        this.gridApi.paginationGoToPage(val - 1);
      },
    },
    listMailErrorComputed () {
      let listmailError = [];
      if ( !this.listMailError || this.listMailError.length == 0){
        listmailError = []
      }
      else{
        this.listMailError.forEach(function (element, index){
        let parsed_body = "";
        parsed_body = element.parsed_body ? element.parsed_body.trim() : "";
        listmailError.push(Object.assign({...element, parsed_body:parsed_body}));
        });
      }
      return listFolder;
    }
  },
  methods: {
    ...mapActions({
      getMailErrors: "mailError/getMailErrors",
    }),
    onSelectionChanged() {
      let selectedrow = this.gridApi.getSelectedRows();
      if (selectedrow[0]) {
        this.listMailError.forEach((element) => {
          if (selectedrow && selectedrow[0].id == element.id) {
            this.inquiry_id_detail = element.inquiry_id ? element.inquiry_id : null;
            this.receive_date_detail = element.receive_datetime ? element.receive_datetime : null;
            this.email_sender_detail = element.email_sender_full ? element.email_sender_full : null;
            this.to_detail = element.to ? element.to : null;
            this.cc_detail = element.cc ? element.cc : null;
            this.subject_detail = element.subject ? element.subject : "";
            this.body_detail = element.body ? element.body : "";
            this.body_type_detail = element.body_type;
            this.error_detail = element.error_detail ? element.error_detail : "";
          }
        });
        this.activePopUp = true;
      }
    },
    onSortChangedEvent(event) {
      let columns = event.columnApi.getAllColumns();
      let root = this;
      columns.forEach(function (column) {
        if (column.getSort()) {
          if (column.getColId() == 'parsed_body'){
            root.orderBy = 'body'
          }
          else{
            root.orderBy = column.getColId();
          }
          root.orderDir = column.getSort();
          root.searchMailWithOrder();
          return;
        }
      });
    },
    async searchMailWithOrder() {
      let search = {
        orderBy: this.orderBy,
        orderDir: this.orderDir,
        error_mail_datetime_from: this.dateFromSearch,
        error_mail_datetime_to: this.dateToSearch,
        error_mail_email_sender: this.emailSenderSearch,
        to: this.toSearch,
        subject: this.subjectSearch,
        body: this.bodySearch,
        limit: this.paginationPageSize,
        page: this.pageNumber,
      };
      await this.getMailErrors(search);
    },
    async resetColFilters() {
      // Reset Grid Filter
      this.gridApi.setFilterModel(null);
      this.gridApi.onFilterChanged();
      (this.emailSenderSearch = ""),
        (this.toSearch = ""),
        (this.subjectSearch = ""),
        (this.bodySearch = ""),
        (this.dateFromSearch = ""),
        (this.dateToSearch = ""),
        this.$refs.filterCard.removeRefreshAnimation();
      await this.searchMailWithOrder();
    },
    async setPagination(val) {
      this.gridApi.paginationSetPageSize(val);
      this.pageNumber = 1;
      await this.searchMailWithOrder();
    },
  },
  mounted() {
    this.gridApi = this.gridOptions.api;
    if (this.$vs.rtl) {
      const header = this.$refs.agGridTable.$el.querySelector(
        ".ag-header-container"
      );
      header.style.left = `-${String(
        Number(header.style.transform.slice(11, -3)) + 9
      )}px`;
    }
    // save paginationSize to sessionStorage (when fresh browser)
    const root = this;
    window.addEventListener("beforeunload", function () {
      sessionStorage.setItem("paginationPageSize", root.paginationPageSize);
    });
  },
  async created() {
    await this.searchMailWithOrder();
  },
  beforeMount() {
    // set page after load (change route = 10, refresh = save PaginationSize in SessionStorage )
    let paginationPageSize = sessionStorage.getItem("paginationPageSize");
    if (paginationPageSize !== null)
      this.paginationPageSize = paginationPageSize;
  },
  updated() {
    // set paginationPageSize = 10 (default) when change page/route
    sessionStorage.setItem("paginationPageSize", 10);
    // calc number startRow and endRow
    this.$nextTick(() => {
      if (!this.$store.state.loading && this.listMailError.length > 0) {
        this.startRow =
          this.pageNumber * this.paginationPageSize -
          this.paginationPageSize +
          1;
        if (this.listMailError.length == this.paginationPageSize)
          this.endRow = this.pageNumber * this.paginationPageSize;
        else
          this.endRow =
            this.paginationPageSize * this.pageNumber +
            this.listMailError.length -
            this.paginationPageSize;
      }
      if (this.listMailError.length == 0) {
        this.endRow = 0;
        this.startRow = 0;
      }
    });
  },
  destroyed() {
    // hiden popup
    document.getElementById("dialogDetail").style.display = "none";
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/vuexy/components/view/mailError.scss";
@import "@/assets/scss/vuexy/components/view/receivedMailDetail.scss";
</style>
